<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <div class="content-wrapper">
        <div class="container-wrapper center">

          <div>
            <h3 class="d-inline heading">Welcome, {{ $store.state.first_name }}!</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <div class="mentor-container">
            <flash-message autoHide variant="success"></flash-message>
            <div class="row db-row mb-2" v-if="this.$store.state.user_locations.isUserLinkedMultipleLocations">
              <div class="col-12">
                  <img src="@/assets/enterprise/branded_location_icon.png" width="16">
                  <b>{{ current_location_name }}</b> {{ formatAddress(current_location_city,current_location_state) }}
              </div>
            </div>
            <div class="row db-row col-11 p-0" style="margin: 0 auto;">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" >
                  <db-card-list v-if="isApprenticesPanelVisible" 
                    card_title="Apprentices"
                    btnName="Add Apprentice"
                    btnLink="/add-apprentice"
                    btnType="add"
                    :count="apprenticesCount" 
                    :itemLength="apprenticesItems.length" 
                    :allItems="apprenticesItems"
                    tab_name="apprentices">
                  </db-card-list>
                  <db-card-list v-if="isMenteePanelVisible" 
                    card_title="Mentees"
                    btnName="Add Mentee"
                    btnLink="/add-mentee"
                    btnType="add"
                    :count="menteeCount" 
                    :itemLength="menteeItems.length" 
                    :allItems="menteeItems"
                    tab_name="mentees">
                  </db-card-list>
                    <db-card-list
                      card_title="Mentors"
                      btnName="Add Mentor"
                      btnLink="/add-mentor"
                      btnType="edit"
                      isListType="mentor"
                      :count="mentorCount" 
                      :itemLength="mentorItems.length" 
                      :allItems="mentorItems"
                      tab_name="mentors">
                    </db-card-list>
                </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div class="db-card">
                    <div class="col-12 p-0">
                      <h5 class="title">Reporting</h5>
                    </div>
                    <div class="col-12 p-0">
                      <div class="db-report-card" v-for="(item, index) in reportingItems" :key="index">
                        <div class="row" v-if="menteeCount > 0 || apprenticesCount > 0">
                          <div class="col-8 col-sm-10 col-md-8 col-lg-8 col-xl-8">
                            {{ item.name }}
                          </div>
                          <div class="col-4 col-sm-2 col-md-4 col-lg-4 col-xl-4" style="padding-right: 5px; text-align: right;">
                            <router-link :to="item.link" class="btn btn-primary btn-sm dbViewBtn">
                            View
                            </router-link>
                          </div>
                        </div>
                      </div>    
                    </div>
                  </div>
                  <div class="db-card">
                    <div class="col-12 p-0">
                      <h5 class="title">Assessments</h5>
                    </div>
                    <div class="col-12 p-0" v-if="assessments.length > 0">
                      <div class="" v-for="(assessment, aindex) in assessments" :key="aindex">
                        <div class="db-report-card">
                        <div class="row" >
                          <div class="col-6">
                            <strong>{{ assessment.title }}</strong>
                            <div class="question_text">
                            {{ assessment.question_count }} Questions
                            </div>
                          </div>
                          <div class="col-6 p-0" style="padding-top: 3px !important;">
                            <div class="col-12" style="text-align: right;">
                              <button type="submit" class="btn btn-primary btn-md  send-assessment" v-on:click="sendAssessmentAction(assessment.id, assessment.title)">Send</button> 
                              <button type="submit" class="btn btn-primary btn-md start-button-blue" v-on:click="goToAssessmentLanding(assessment.id, assessment.inprogress_attempt_id, assessment.question_count)">{{ assessment.button_text }}</button> 
                            </div>
                            <div class="col-12 question_text color-blue" style="text-align: right; padding-right: 16px; padding-top: 6px; text-decoration: underline;"  v-if="assessment.complete_attempt_id"> 
                              <router-link :to="'assessment-report/' + assessment.complete_attempt_id" style="">
                              View Results
                              </router-link>
                            </div>
                          </div>

                        </div>
                        </div>
                      </div>    
                    </div>

                    <div class="col-12 p-0" v-if="forms.length > 0">
                      <div class="db-report-card" v-for="(form, findex) in forms" :key="findex">
                        <div class="row" >
                          <div class="col-8 col-sm-10 col-md-8 col-lg-8 col-xl-8">
                            <strong>{{ form.name}}</strong>                           
                          </div>
                          <div class="col-4 col-sm-2 col-md-4 col-lg-4 col-xl-4 p-0" style="padding-top: 3px !important;">
                            <div class="col-12" style="text-align: right;">
                            <button type="submit" class="btn btn-primary btn-md start-button-blue " v-on:click="goToFillForm(form.id)">Fill Form</button> 
                            </div>
                            
                          </div>
                        </div>
                      </div>    
                    </div>
                    <div class="col-12 p-0" v-if="assessments.length == 0 && forms.length == 0">
                      <div class="db-report-card" style="font-style: italic; font-weight: bold;font-size: 13px; text-align: center;" >
                          No Assessments Assigned
                      </div>
                    </div>


                  </div>

                  <div class="db-card" v-if="courses.length > 0 || resources.length > 0">
                      <div class="col-12 p-0">
                        <h5 class="title">Courses</h5>
                      </div>

                      <div class="col-12 p-0" v-if="resources.length > 0">
                      <div class="db-report-card" v-for="(resource, rindex) in resources" :key="rindex">
                        <div class="row" >
                          <div class="col-8 col-sm-10 col-md-8 col-lg-8 col-xl-8">
                            <strong>{{ resource.name }}</strong>
                            <div class="question_text">
                            Resource
                            </div>
                          </div>
                          <div class="col-4 col-sm-2 col-md-4 col-lg-4 col-xl-4 p-0" style="padding-top: 3px !important;">
                            <div class="col-12" style="text-align: right;">
                            <button type="submit" class="btn btn-primary btn-md begin-course-button" @click="getResourceView(resource.filename)">View</button> 
                            </div>                          
                          </div>
                         </div>
                       </div>    
                      </div>

                      <div class="col-12 p-0" v-if="courses.length > 0">
                      <div class="db-report-card" v-for="(course, cindex) in courses" :key="cindex">
                        <div class="row" >
                          <div class="col-8 col-sm-10 col-md-8 col-lg-8 col-xl-8">
                            <strong>{{ course.title }}</strong>
                            <div class="question_text">
                            {{ course.noOfModules }} Modules
                            </div>
                          </div>
                          <div class="col-4 col-sm-2 col-md-4 col-lg-4 col-xl-4 p-0" style="padding-top: 3px !important;">
                            <div class="col-12" style="text-align: right;">
                            <button type="submit" class="btn btn-primary btn-md begin-course-button" v-on:click="goToCourseLanding(course.lmsCourseId)">{{getCourseBtnName(course.certification_download_link, course.courseStatus)}}</button> 
                            </div>
                            <div class="col-12 view-certificate" v-if="course.certification_download_link"> 
                              <a :href="course.certification_download_link" target="_blank">View Certificate</a>
                            </div>
                          </div>
                        </div>
                      </div>    
                    </div>
                      
                  </div>

                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

 <!-- Bell icon to see the introduction slide -->
    <div class="fixed-bell-icon btn btn-primary" @click="showIntroductionSlide" v-if="introduction_slide_obj.length > 0">
       <i class="fa fa-bell" aria-hidden="true"></i>       
    </div>

      <SendAssessment :isModalVisible="isModalVisible" @close="isModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"><h3>Send {{ selected_assessment_title }}</h3></div>
        <div slot="body" class="send-assessment-content">
        <div v-for="(list, index) in pending_mentors">
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <div class="col-6 p-0 float-left">
              <input v-model="list.first_name"
                    v-bind:id="'fname_' + index"
                    ref="fname"
                    v-bind:name="'fname[' + index + ']'"
                    placeholder="First Name"
                    class="col-lg-11 input-height-25"
                    v-validate="{ rules: { required: true, regex: nameRegex() } }"
                    autocomplete="off"
                    maxlength="255" />
              <div v-if="verrors.firstByRule('fname[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">First name is required</div>
              <div v-if="verrors.firstByRule('fname[' + index + ']', 'regex')" class="margin-bottom-5 validate-warning-msg">First name should only contain - and _</div>
            </div>
            <div class="col-6 p-0 float-left">
              <input v-model="list.last_name"
                    v-bind:id="'lname_' + index"
                    ref="lname"
                    v-bind:name="'lname[' + index + ']'"
                    placeholder="Last Name"
                    class="col-lg-12 input-height-25"
                    v-validate="{ rules: { required: true, regex: nameRegex() } }"
                    autocomplete="off"
                    maxlength="255" />
              <div v-if="verrors.firstByRule('lname[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Last name is required</div>
              <div v-if="verrors.firstByRule('lname[' + index + ']', 'regex')" class="margin-bottom-5 validate-warning-msg">Last name should only contain - and _</div>
            </div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" v-if="pending_mentors.length == 1">
              <input v-model="list.email"
                    v-bind:id="'email_' + index"
                    ref="email"
                    v-bind:name="'email[' + index + ']'"
                    placeholder="Email"
                    class="col-lg-12 input-height-25"
                    v-validate="'required|email'"
                    maxlength="255" />
              <div v-if="verrors.firstByRule('email[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Email is required</div>
              <div v-if="verrors.firstByRule('email[' + index + ']', 'email')" class="margin-bottom-5 validate-warning-msg">Email is invalid</div>
              <div v-if="verrors.firstByRule('email[' + index + ']', 'exists')" class="margin-bottom-5 validate-warning-msg">Email address already exists</div>
          </div>
          <div class="col-12 override-padding" v-if="pending_mentors.length > 1">
            <div class="col-10 p-0 float-left">
              <input v-model="list.email"
                    v-bind:id="'email_' + index"
                    ref="email"
                    v-bind:name="'email[' + index + ']'"
                    placeholder="Email"
                    class="col-lg-12 input-height-25"
                    v-validate="'required|email'"
                    maxlength="255" />
              <div v-if="verrors.firstByRule('email[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Email is required</div>
              <div v-if="verrors.firstByRule('email[' + index + ']', 'email')" class="margin-bottom-5 validate-warning-msg">Email is invalid</div>
              <div v-if="verrors.firstByRule('email[' + index + ']', 'exists')" class="margin-bottom-5 validate-warning-msg">Email address already exists</div>
            </div>
            <div class="col-2 p-0 float-right remove-mentors">
              <span style="cursor: pointer" v-on:click="removeMentor(index)">  
                Remove
              </span>
            </div>
          </div>

        </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 p-0 additional-mentor">
            <span style="cursor: pointer" v-on:click="addMentor()">
              + additional mentor
            </span>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
              <textarea
                  name="pending_mentor_comments" 
                  v-model="pending_mentor_comments"
                  placeholder="Message"
                  class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25"
                  maxlength="500" rows="5">
                  </textarea>
              <div v-if="verrors.firstByRule('pending_mentor_comments', 'required')" class="margin-bottom-5 validate-warning-msg">Tasklist title is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
            <button
                @click="isModalVisible = false"
                class="btn btn-md btn-grey col-lg-2 col-sm-2 col-3 input-height-25 createBtn"  style="border-radius: 5px;"
                ><b>Cancel</b></button>
            <button
                @click="SendAssessment()"
                class="btn float-right btn-md btn-red col-lg-2 col-sm-2 col-3 input-height-25 createBtn" style="border-radius: 5px;"
                ><b>Send</b></button>
            <div style="clear: both;"></div>
        </div>
        <div slot="footer" class="col-3 p-0">

        </div>
      </SendAssessment>





      <ProcessPaymentModal :isModalVisible="isProcessPaymentModalVisible" @close="isProcessPaymentModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading process-payment-modal" style="margin-left: 5px; background-color: #18374A; "><h3 style=" color: #FFF !important; padding: 10px 20px 6px 20px; border-radius: 0 !important;">Invoice Due</h3></div>
        <div slot="body" class="send-assessment-content">
          <div class="col-12 p-0">
            <div class="col-7 p-0 float-left">
              <div class="process-text bold">{{ ppAccountName }}</div>
              <div class="process-text">{{ ppPrimaryName }}</div>
              <div class="process-text">{{ ppAddress }}</div>
              <div v-if="ppState" class="process-text">{{ ppCity }}, {{ ppState }} {{ ppZip }}</div>
              <div v-else class="process-text">{{ ppCity }} {{ ppZip }}</div>
              <div class="process-text bold" style="margin-top: 10px;">Number of Licenses:</div>
              <div class="process-text">{{ ppLicenseCount }}x Mentee License</div>
              <div class="process-text bold" style="margin-top: 10px;">Total Dues:</div>
              <div class="process-text"><span class="dollarsign" >$</span> {{ppDueAmount}}</div>
            </div>
            <div class="col-5 p-0 float-left">
              <div class="process-text bold" style="margin-top: 0px;">Invoice Date:</div>
              <div class="process-text">{{ ppInvoiceDate }}</div>
              <div class="process-text bold" style="margin-top: 10px;">Due Date:</div>
              <div class="process-text">{{ ppDueDate }}</div>
              <div class="process-text bold" style="margin-top: 10px;">Invoice No:</div>
              <div class="process-text">{{ ppInvoiceNo }}</div>
            </div>
            <div style="clear: both;"></div>
            <div class="col-12 p-0" style="margin-top: 5px;">
              <div class="col-6 p-0 float-left" style="text-align: right; padding-right: 10px !important;">
                <button type="submit" class="btn btn-md ma-blue-btn" @click="getInvoicePdf()">View Invoice</button>
              </div>
              <div class="col-6 p-0 float-left" style=" padding-left: 10px !important;">
                <button type="submit" class="btn btn-md ma-blue-btn" style="width: 150px;" @click="processPayment(ppOrderId)">Process Payment</button>
              </div>
            </div>
            <div style="clear: both;"></div>

          </div>
        </div>
        <div slot="footer" class="col-3 p-0 text-align-right" >
          <div style="padding-right: 20px; cursor: pointer;" @click="isProcessPaymentModalVisible = false">Close</div>
        </div>
      </ProcessPaymentModal>


      <IntroductionModal
      :isIntroductionModalVisible="isIntroductionModalVisible"
      :introductionSlideObj="introduction_slide_obj"
      :showSlideNumbers="showSlideNumbers"
      ref="introduction_modal"
      @close="isIntroductionModalVisible = false"
      >

      </IntroductionModal>



  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import { store } from '../../store/store';
import DbCardList from './db_card_list.vue';
import SendAssessment from './send_assessment_mentor_modal.vue';
import ProcessPaymentModal from './invoice_due_modal.vue';
import IntroductionModal from './introductionManagerTemplateModal.vue';
import router from '../../router/index.js';
import VeeValidate from 'vee-validate';
import { Validator } from "vee-validate";

const today = new Date();
today.setHours(0, 0, 0, 0);

const reportingLists = [
  {'name': 'Competency Progress', 'link': 'competency-report'},
  {'name': 'Rep Audit Trail', 'link': '/rep-audit-trail'},
  // {'name': 'Course Certificate', 'link': '/'}
];

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    data: function () {
        return {
            loading: false,
            accountItems: [],
            mentors: [],
            managerItems: [],
            mentorItems: [],
            menteeItems: [],
            apprenticesItems: [],
            managerCount: '',
            mentorCount: '',
            menteeCount: '',
            apprenticesCount: '',
            reportingItems: reportingLists, 
            assessments: [],
            courses: [],
            lmsUserId: '',
            isApprenticesPanelVisible: false,
            isMenteePanelVisible: false,
            isProcessPaymentModalVisible: false,
            forms:[],
            current_location_name: '',
            current_location_city: '',
            current_location_state: '',
            currentLocation: {},
            isModalVisible: false,
            pending_mentors: [
              {
                first_name: '',
                last_name: '',
                email: '',
              }
            ],
            pending_mentor_comments: '',
            selected_assessment: '',
            selected_assessment_title: '',
            currentUserName: '',
            ppAccountName: '',
            ppPrimaryName: '',
            ppAddress: '',
            ppCity: '',
            ppState: '',
            ppZip: '',
            ppLicenseCount: '',
            ppDueAmount: 0,
            ppInvoiceDate: '',
            ppDueDate: '',
            ppInvoiceNo: '',
            ppOrderId: '',
            ppOrderBillingDetails: [],
            resources: [],
            introduction_slide_obj: [],
            isIntroductionModalVisible: false,
            showSlideNumbers: false,
        }
    },
    beforeCreate: function() {
      store.dispatch('active_tab', '');
   },
   methods: {
      processPayment: function(orderId) {
        this.$store.dispatch('invoice_due_order_id', orderId);
        this.isProcessPaymentModalVisible = false;
        router.push("/manage-license");
      },
      getInvoicePdf() {
        let pdfEndPoint;
        pdfEndPoint = '/getOrderInvoicePdf';
        axios(pdfEndPoint,
        {
          method: 'POST',
          data: {
              "billing": {
                  "billing_name": this.ppOrderBillingDetails.billingName,
                  "billing_address": this.ppOrderBillingDetails.billingAddress,
                  "billing_address2": this.ppOrderBillingDetails.billingAddress2,
                  "billing_city": this.ppOrderBillingDetails.billingCity,
                  "billing_country": this.ppOrderBillingDetails.billingCountry,
                  "billing_phone": this.ppOrderBillingDetails.billingPhone,
                  "billing_state": this.ppOrderBillingDetails.billingState,
                  "billing_zip": this.ppOrderBillingDetails.billingZip,
                  "billing_primary_admin": this.ppPrimaryName,
              },
              "orderId": this.ppOrderId
          }
          },
        )
        .then(response => {
          window.open(response.data.invoice_filepath, '_blank');
        })
        .catch(error => {
          console.log(error)
        });
      },      
      sendAssessmentAction: function(assessmentId, asssessmentName) {
        
        this.errors = '';
        this.verrors.clear();
        this.pending_mentors = [
          {
            first_name: '',
            last_name: '',
            email: '',
          }
        ],
        this.pending_mentor_comments = '',
        this.selected_assessment = '',
        this.selected_assessment_title = '',      
        this.selected_assessment = assessmentId;
        this.selected_assessment_title = asssessmentName;
        this.pending_mentor_comments = 'Hello {First Name} {Last Name},\n\n' + this.currentUserName + ' has sent you an assessment using Mentor Mentee.';
        this.isModalVisible = true;
      },
      nameRegex: function() {
        return /^[a-zA-Z-_ ']*$/;
      },
      addMentor: function() {
        this.pending_mentors.push({
          first_name: '',
          last_name: '',
          email: '',
        });
      },
      removeMentor: function(index) {
        this.pending_mentors.splice(index, 1);
      },
      SendAssessment() {
        this.$validator.validateAll().then((result) => {
          if ((this.verrors.items.length === 0)) {
            axios('/send-mentor-assessment',
               {
                 method: 'POST',
                 data:
                  {
                    mentors: this.pending_mentors,
                    pending_mentor_comments: this.pending_mentor_comments,
                    selected_assessment: this.selected_assessment,
                  },
               }
             )
            .then((resp) => {
                this.isModalVisible = false;
                router.push("/company-admin-dashboard");
             })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
              const fieldErrors =  [];
              // var errMsgObj = error.response.data.message;
              var errMsgObj = JSON.parse(error.response.data.message);
              Object.keys(errMsgObj).map(key => {
              var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                fieldErrors.push(newFieldErr);
              });
              this.$validator.errors.add(fieldErrors);



            });

          }
        })
        .catch(() => {

        });
      },

      goToAssessmentLanding: function(assessmentId, assessmentAttemptId, questionCount) {
        if(assessmentAttemptId) {
          router.push('/assessment-landing-page/' + assessmentId + '/' + assessmentAttemptId);
        }
        else {
          axios('/desktop/user-assessment-attempts/' + assessmentId + '/' + this.$store.state.user_accountid,
          {
            method: 'POST',
          })
          .then((resp) => {
            router.push('/assessment-landing-page/' + assessmentId + '/' + resp.data);
          })
          .catch(() => {

          });
        }
      },
     goToCourseLanding(courseId) {
        var dashboardPath = this.$route.fullPath;
        dashboardPath = dashboardPath.replace(/^\/+/,"");
       
        router.push('/take-course/'+ this.lmsUserId + '/' + dashboardPath + '?c=' + courseId);
     },
     goToFillForm: function(formId) {
        router.push('/display-fill-form/' + formId);
     },
     getCourseBtnName(certificate, courseStatus) {
      var res = 'Begin';
        if(certificate) {
          res = 'Re-Take';
        }
        else if(courseStatus == 1) {
          res = 'Continue';
        }
       return res;
     },
    formatAddress(city, state) {
      var address = '';
      if (city) {
          address += city + ", ";
      }
      if (state) {
          address += state + ", ";
      }
      return address.slice(0, -2);
    },
    getResourceView(fileLink) {
      window.open(fileLink, '_blank');
    },
    showIntroductionSlide() {
      this.$refs.introduction_modal.getDefaultSlide();
      this.isIntroductionModalVisible = true;      
    }
   },
   created() {
      if (this.$store.state.user_locations.isUserLinkedMultipleLocations) {
        this.currentLocation = this.$store.state.user_locations.locations.find(loc => loc.accId === this.$store.state.user_accountid);
        this.current_location_name = this.currentLocation.accountName;
        this.current_location_city = this.currentLocation.city;
        this.current_location_state = this.currentLocation.stateName;
      }
      var roles = store.state.roles;
      if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
        this.admin = true;
      }

      axios('/mobile/manager/my-account-lists',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        this.accountItems = resp.data;
        this.managerCount = this.accountItems.manager.length;
        this.mentorCount = this.accountItems.mentor.length;
        this.menteeCount = this.accountItems.mentee.length;
        this.apprenticesCount = this.accountItems.apprentice.length;
        this.managerItems = this.accountItems.manager;
        this.mentorItems = this.accountItems.mentor;
        this.menteeItems = this.accountItems.mentee;
        this.apprenticesItems = this.accountItems.apprentice;
        this.currentUserName = this.accountItems.currentUserName;
        if (this.accountItems.program == 'Apprenticeship' || this.accountItems.program == 'Mentorship & Apprenticeship') {
          this.isApprenticesPanelVisible = true;
        }
        if (this.accountItems.program == 'Mentorship' || this.accountItems.program == 'Mentorship & Apprenticeship') {
          this.isMenteePanelVisible = true;
        }
        
       var role = 'ROLE_ADMIN'; 
       if((roles.indexOf('ROLE_ADMIN') > -1) && (roles.indexOf('ROLE_MENTOR') > -1)) {
          role = 'ROLE_ADMIN,ROLE_MENTOR';
       }

       axios.get('/desktop/user/resource-lists', {
          params: {
          user_roles: role,
          accountId: this.$store.state.user_accountid
          }
        })
        .then(response =>  {
          this.resources = response.data;
        })
        .catch(function() {
          
        });


        axios.get('/desktop/user/course-lists/' + this.$store.state.user_accountid, {
        })
        .then(response =>  {
          this.courses = response.data.course;
        })
        .catch(function() {
          console.log("Come here");
        });

        axios.get('/user/get-lmsuserid', {
        })
        .then(response =>  {
          this.lmsUserId = response.data.lmsuserid;
        })
        .catch(function() {
          
        });

        axios.get('/desktop/user/assessment-lists/' + this.$store.state.user_accountid, {
        })
        .then(response =>  {
          this.assessments = response.data.assessment;
        })
        .catch(function() {
          console.log("Come here");
        });

        axios.get('/desktop/user/form-lists/' + this.$store.state.user_accountid, {
          params: {
            user_roles: 'ROLE_ADMIN',
          }
        })
        .then(response =>  {
          this.forms = response.data;
        })
        .catch(function() {
          
        });
        
      })
      .catch(() => {
      });
      var flag = 0;
      if((!this.$store.state.invoice_due_modal_date) || (this.$store.state.invoice_due_modal_date < today)) {
        flag = 1;
      }

      axios.get('/get-dashboard-introduction-slide', {
          params: {
            user_roles: 'ROLE_ADMIN',
            accountId: this.$store.state.user_accountid,
          }
      })
      .then(response =>  {
        this.introduction_slide_obj = response.data.introduction_slide;
        this.showSlideNumbers = response.data.showSlideNumbers;
        if(this.introduction_slide_obj.length > 0) {
        if(this.$store.state.introduction_template_display == 1) {
          setTimeout(() => {
          this.$refs.introduction_modal.getDefaultSlide();

          this.isIntroductionModalVisible = true;
          this.$store.dispatch('introduction_template_display', 0);
          }, 1000);
        }
        }
      })
      .catch(function() {
        
      });


      
      if((flag == 1) && (((roles.indexOf('ROLE_BILLING_ADMIN') > -1) || (roles.indexOf('ROLE_PRIMARY_ADMIN') > -1)))) {
        axios.get('/get-last-process-payment-order-details', {
        })
        .then(response =>  {
          this.ppAccountName = response.data.account_name;
          this.ppPrimaryName = response.data.account_primary_admin;
          this.ppAddress = response.data.account_address;
          this.ppCity = response.data.account_city;
          this.ppState = response.data.account_state;
          this.ppZip = response.data.account_zip;
          this.ppInvoiceNo = response.data.invoice;
          this.ppDueAmount = response.data.price;
          this.ppOrderId = response.data.order_id;
          if(this.ppOrderId) {
            this.isProcessPaymentModalVisible = true;
            this.$store.dispatch('invoice_due_modal_date', today);
          }
          this.ppLicenseCount = response.data.license_count;
          this.ppInvoiceDate = response.data.invoice_date;
          this.ppDueDate = response.data.due_date;
          this.ppOrderBillingDetails = response.data.billing_info;
        })
        .catch(function() {
          console.log("Come here");
        });
      }
      



   },

   components: {
    UserMenu,
    DbCardList,
    SendAssessment,
    ProcessPaymentModal,
    IntroductionModal,
   },
}
</script>

<style scoped>
.mentor-container {
  margin: 0px auto;
  width: 100%;
  padding-top: 0px;
}
.db-card {
  color: #002F42;
  background-color: #FFF;
  width: 100%;
  min-height: 120px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;  
}
.db-card .title{
  font-size: 15px;
  font-weight: 900;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.db-card .acc-info {
  font-size: 13px;
  font-weight: 600;
  margin-left: 10px;
}
.db-card .db-report-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
.dbViewBtn{
  color: #29A3E4;
  background: none;
  border: 0px solid #00acee;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  width: 50px;
  float: right;
  text-decoration: underline !important;
}
.dbViewBtn:focus, .dbViewBtn:hover {
  color: #29A3E4 !important;
  background: none !important;
  box-shadow: none !important;
  border: 0px solid #00acee !important;
} 
/* media query css start */
@media (min-width: 992px) {
  .db-row {
    margin-left: 1rem;
  }
}
.question_text, .question_text a, .question_text a:hover {
  font-size: 11px;
  color: #002F42;
}
.color-blue a, .color-blue a:hover{
  color: #29A3E4 !important;
  text-decoration: underline !important;
  font-weight: bold;
}
.start-button {
    color: #29A3E4 !important;
    background-color: #FFF !important;
    border: 1px solid #29A3E4 !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 87px;
}
.begin-course-button {
    color: #fff;
    background-color: #29A3E4 !important;
    border: 1px solid #29A3E4 !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 87px; 
}
.start-button-blue {
    color: #fff;
    background-color: #29A3E4 !important;
    border: 1px solid #29A3E4 !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 87px; 
}
.view-certificate {
    text-align: right;
    padding: 6px 16px 3px 30px;
    font-size: 11px;
    color: #29A3E4;
}
.view-certificate a, .view-certificate a:hover{ 
  color: #29A3E4 !important;
  text-decoration: underline !important;
  font-weight: bold;
}
.ma-white-btn {
  color: #29A3E4 !important; 
  border-radius: 10px;
  background-color: #FFF !important;
  border: 1px solid #29A3E4 !important;
  font-weight: 900;
  width: 150px;
}
.send-assessment {
    color: #29A3E4 !important;
    border-radius: 10px;
    background-color: #FFF !important;
    border: 1px solid #29A3E4 !important;
    font-weight: 900;
    line-height: 8px;
    padding: 10px 10px 10px 10px;
    font-size: 13px;
    width: 87px;
}
.send-assessment-content input, .send-assessment-content textarea {
  border: 1px solid #CCC;
  border-radius: 5px;
  resize: none;
}
.additional-mentor {
  text-align: right;
  color: #29A3E4;
  font-size: 14px;
}
.remove-mentors {
  text-align: right;
  color: #FF0000;
  font-size: 14px;
  padding-top: 5px !important;
}
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.ma-blue-btn {
  color: #FFF !important; 
  border-radius: 10px;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 130px;
  padding: 4px;
}
.fixed-bell-icon {
    position: fixed;
    right: 15px;
    bottom: 30px;
    border-radius: 50%;
    box-shadow: 1px 1px 11px 1px #a59a9a;
    font-size:25px;
    background-color: #29A3E4 !important;
    border-color: #29A3E4 !important; 
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/manager_dashboard.vue